import gql from "graphql-tag"

export default gql`
  fragment fullOldTeam on Team {
    Etag
    owners
    permissions
    public_name
    teamName
    state
    uuid
  }
`
